<template>
  <div class="x-tablelist-view api-code">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @input="search"
      @search="search"
      @add="showAdd"
      @resetsearch="resetsearch"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :emptyText="$t('HT.nodata')"
        :columns="columns"
        layout="total, prev, pager, next, jumper"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addCode from './template/addCode';
export default {
  components: {
    addCode
  },
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'message',
          placeholder: this.$t('HT.apiCode.message.placeholder')
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        },
        {
          type: 'button',
          right: true,
          text: this.$t('HT.add'),
          icon: 'ux_icon_plus',
          hidden: !this.$hasModule(18),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.addCode.code'),
          prop: 'code',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'message',
          align: 'left',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          label: this.$t('HT.addCode.errCode'),
          tooltip: true,
          align: 'left',
          prop: 'sub_code',
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          label: this.$t('HT.addCode.errMsg'),
          tooltip: true,
          align: 'left',
          prop: 'sub_message',
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          label: this.$t('HT.apiStepThree.http'),
          tooltip: true,
          align: 'left',
          prop: 'http_status'
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(18),
          align: 'left',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.edit'), this.$t('HT.delete')],
                colors: ['#0087ff'],
                event: ['edit', 'del']
              },
              on: {
                edit: () => {
                  this.showEdit(params);
                },
                del: () => {
                  const title = this.$t('HT.apiCode.del');
                  const content = this.$t('HT.apiCode.del.placeholder');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        page: 1,
        // size: '',
        message: '' //错误描述
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 搜索
     */
    search() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.code.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 重置搜索项
    */
    resetsearch() {
      console.log('重置');
      this.filter.message = '';
      this.search();
    },
    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      this.$api.code.addList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 修改列表
     * @param {Object} params 表单提交参数
     */
    putList(params) {
      this.$uxLoading.show();
      this.$api.code.putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.code.delList(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.model.showAdd');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addCode, {
            on: {}
          });
        },
        confirm: (data) => {
          this.addList(data);
        }
      });
    },

    /**
     * 编辑
     * @param {Object} params 单行表格数据
     */
    showEdit(params) {
      const title = this.$t('HT.apiCode.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addCode, {
            props: { data: params },
            on: {}
          });
        },
        confirm: (data) => {
          this.putList(data);
        }
      });
    },

    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 4) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
